import ApiService from '@/common/api.service'
import ErrorsService from './errors.service'
import Constants from '@/common/constants'
import { FETCH_LAYERS, FETCH_LAYER, LAYER_ADD_RULE, LAYER_REMOVE_RULE, LAYER_SAVE_INFO, LAYER_SAVE_ATTRIBUTES, FETCH_ERROR } from './actions.type'
import { SET_LAYERS, SET_LAYERS_ERRORS, SET_LAYERS_LOADING, SET_LAYER, SET_LAYER_ERRORS, SET_LAYER_LOADING, SET_LAYER_ADD_RULE_ERRORS, SET_LAYER_ADD_RULE_LOADING, SET_LAYER_INFO_ERRORS, SET_LAYER_INFO_LOADING, LAYERS_SORT, SET_MAP_ID } from './mutations.type'

const state = {
	layers: [],
	layersErrors: [],	
	layersIsLoading: false,
	layer: [],
	layerErrors: [],	
	layerIsLoading: false,
	layerAddRuleErrors: [],
	layerAddRuleIsLoading: false,
	layerInfoErrors: [],	
	layerInfoIsLoading: false,
	map_id: Constants.NEW_ID_STRING
}

const getters = {
	layers : state => key => {
		return state.layers.filter(x =>
			x.name.toLowerCase().includes(key.toLowerCase()) ||
			(x.title && x.title.toLowerCase().includes(key.toLowerCase())) ||
			x.tags.indexOf(key) >= 0
		)
	},
	layersErrors (state) {
		return state.layersErrors
	},
	layersIsLoading (state) {
		return state.layersIsLoading
	},
	layer (state) {
		return state.layer
	},
	layerErrors (state) {
		return state.layerErrors
	},
	layerIsLoading (state) {
		return state.layerIsLoading
	},
	layerAddRuleErrors (state) {
		return state.layerAddRuleErrors
	},
	layerAddRuleIsLoading (state) {
		return state.layerAddRuleIsLoading
	},
	layerInfoErrors (state) {
		return state.layerInfoErrors
	},
	layerInfoIsLoading (state) {
		return state.layerInfoIsLoading
	},
	map_id (state) {
		return state.map_id
	}
}

const actions = {
	[FETCH_LAYERS] (context, params) {
		context.commit(SET_LAYERS_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.query('manager/layers')
			.then(({data}) => {
				if (typeof data == "object") {
					context.commit(SET_LAYERS, data)
					resolve(data)
				} else {
					context.commit(SET_LAYERS_ERRORS, ["Разрыв сессии"])
				}
			})
			.catch((error) => {
				ErrorsService.setFetchError(SET_LAYERS_ERRORS, context, error)
			})
			.finally(x => {
				context.commit(SET_LAYERS_LOADING, false)
			})
		})
	},
	[FETCH_LAYER] (context, params) {	
		context.commit(SET_LAYER_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.getBy('manager/layers', params.name)
			.then(({data}) => {
				if (typeof data == "object") {
					context.commit(SET_LAYER, data)
					resolve(data)
				} else {
					context.commit(SET_LAYER_ERRORS, ["Разрыв сессии"])
				}
			})
			.catch((error) => {
				ErrorsService.setFetchError(SET_LAYER_ERRORS, context, error)
			})
			.finally(x => {
				context.commit(SET_LAYER_LOADING, false)
			})
		})
	},
	[LAYER_ADD_RULE] (context, params) {
		context.commit(SET_LAYER_ADD_RULE_LOADING)
		context.commit(SET_LAYER_ADD_RULE_ERRORS)
		return new Promise((resolve, reject) => {
			ApiService.post(`manager/layers/${params.layerName}/rules`, params.body)
			.then(({data}) => {
				if (data === true) {
					// В данный момент контроллер присылает true даже если доступ, который нужно добавить, уже существует
					// Уведомление об успехе будет показываться там, где откуда пришел вызов
				} else {
					this.dispatch(FETCH_ERROR, { text: "Не удалось добавить доступ" })
				}
				resolve(data)
			})
			.catch((error) => {
				this.dispatch(FETCH_ERROR, { text: "Не удалось добавить доступ" })
				ErrorsService.setFetchError(SET_LAYER_ADD_RULE_ERRORS, context, error)
			})
			.finally(x => {
				context.commit(SET_LAYER_ADD_RULE_LOADING, false)
			})
		})
	},
	[LAYER_REMOVE_RULE] (context, params) {
		context.commit(SET_LAYER_ADD_RULE_LOADING)
		context.commit(SET_LAYER_ADD_RULE_ERRORS)
		return new Promise((resolve, reject) => {
			ApiService.put(`manager/layers/${params.layerName}/rules`, params.body)
			.then(({data}) => {
				if (data) {
					this.dispatch(FETCH_ERROR, { variant: "success", text: "Доступ удален", title: "Готово" })
				}
				else {
					this.dispatch(FETCH_ERROR, { text: "Не удалось удалить доступ" })
				}
				resolve(data)
			})
			.catch((error) => {
				this.dispatch(FETCH_ERROR, { text: "Не удалось удалить доступ" })
				ErrorsService.setFetchError(SET_LAYER_ADD_RULE_ERRORS, context, error)
				resolve(false)
			})
			.finally(x => {
				context.commit(SET_LAYER_ADD_RULE_LOADING, false)
			})
		})
	},
	[LAYER_SAVE_INFO] (context, params) {
		context.commit(SET_LAYER_INFO_LOADING)
		context.commit(SET_LAYER_INFO_ERRORS)
		return new Promise((resolve, reject) => {
			ApiService.put(`manager/layers/${params.layerName}/info`, params.body)
			.then(({data}) => {
				if (data) {
					this.dispatch(FETCH_ERROR, { variant: "success", text: "Информация по слою сохранена", title: "Готово" })
				}
				else {
					this.dispatch(FETCH_ERROR, { text: "Не удалось сохранить" })
				}
				resolve(data)
			})
			.catch((error) => {
				this.dispatch(FETCH_ERROR, { text: "Не удалось сохранить" })
				ErrorsService.setFetchError(SET_LAYER_INFO_ERRORS, context, error)
				resolve(false)
			})
			.finally(x => {
				context.commit(SET_LAYER_INFO_LOADING, false)
			})
		})
	},
	[LAYER_SAVE_ATTRIBUTES] (context, params) {
		return new Promise((resolve, reject) => {
			ApiService.put(`manager/layers/${params.layerName}/attributes/${params.id}`, params.body)
			.then(({data}) => {
				if (data) {
					this.dispatch(FETCH_ERROR, { variant: "success", text: "Таблица атрибутов сохранена", title: "Готово" })
				} else {
					this.dispatch(FETCH_ERROR, { text: "Не удалось сохранить" })
				}
				resolve(data)
			})
			.catch((error) => {
				this.dispatch(FETCH_ERROR, { text: "Не удалось сохранить" })
				resolve(false)
			})
		})
	}
}

const mutations = {
	[SET_LAYERS] (state, data) {
		state.layers = data
		state.layersErrors = []
	},
	[SET_LAYERS_ERRORS] (state, errors) {
		state.layers = []
		state.layersErrors = errors
	},
	[SET_LAYERS_LOADING] (state, status = true) {
		state.layersIsLoading = status
	},
	[SET_LAYER] (state, data) {
		state.layer = data
		state.layerErrors = []
	},
	[SET_LAYER_ERRORS] (state, errors) {
		state.layer = []
		state.layerErrors = errors
	},
	[SET_LAYER_LOADING] (state, status = true) {
		state.layerIsLoading = status
	},

	[SET_LAYER_ADD_RULE_ERRORS] (state, errors) {
		if (errors === undefined) {
			state.layerAddRuleErrors = []
		}
		else {
			state.workspaceAddRuleErrors = errors
		}
	},
	[SET_LAYER_ADD_RULE_LOADING] (state, status = true) {
		state.layerAddRuleIsLoading = status
	},

	[SET_LAYER_INFO_ERRORS] (state, errors) {
		if (errors === undefined) {
			state.layerInfoErrors = []
		}
		else {
			state.layerInfoErrors = errors
		}
	},
	[SET_LAYER_INFO_LOADING] (state, status = true) {
		state.layerInfoIsLoading = status
	},

	[LAYERS_SORT] (state) {
		state.layers.sort((a,b) => (a.title > b.title) ? 1 : ((b.title > a.title) ? -1 : 0))
	},

	[SET_MAP_ID] (state, id = Constants.NEW_ID_STRING) {
		state.map_id = id
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}


// WEBPACK FOOTER //
// ./src/store/layers.module.js